import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class BuildingBlockInfo {
  private _dispatchBuildingBlockAttached: boolean = false;

  public get dispatchBuildingBlockAttached() {
    return this._dispatchBuildingBlockAttached;
  }

  public set dispatchBuildingBlockAttached(value: boolean) {
    this._dispatchBuildingBlockAttached = value;
  }

  private _createdArticleUsageIds: string[] = [];

  public get createdArticleUsageIds() {
    return this._createdArticleUsageIds;
  }

  public set createdArticleUsageIds(value: string[]) {
    this._createdArticleUsageIds = value;
  }
}
